import { Container, CssBaseline, Paper, Typography } from '@mui/material'
import React from 'react'
import { Navigate, useNavigate } from 'react-router'
import { UserType } from 'redux/models/user'
import { NewActions, NewStoreStates } from '.'
import Form, { FormInputs } from '../Form'

type OwnProps = {}
type NewProps = OwnProps & NewStoreStates & NewActions

const New = (props: NewProps) => {
  const { auth } = props
  const navigate = useNavigate()

  const onSubmit = (inputs: FormInputs) => {
    props.addItem(inputs)
    navigate(-1)
  }

  // 権限なしはリダイレクト
  if (!auth.user || auth.user.type === UserType.User) return <Navigate replace to="/notifications" />

  return (
    <Container>
      <CssBaseline />

      <Paper sx={{ p: 2 }}>
        <Typography variant="h4">お知らせの新規作成</Typography>

        <Form submitTitle="作成" title="" content="" onSubmit={(inputs) => onSubmit(inputs)} />
      </Paper>
    </Container>
  )
}

export default New
